import React, { useState } from 'react';
import Button from '../button';
import { FiX } from 'react-icons/fi';
import { Modal } from 'semantic-ui-react';

import './styles.css';
import { Trans, useTranslation } from 'react-i18next';
import ReactIntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

interface ActivateMFAProps {
    mfaStatus: string;
    onMFAEnableSave: (phone: string) => void;
}

function ActivateMFA(props: ActivateMFAProps) {
    const { t } = useTranslation();
    const [isModalActive, setIsModalActive] = useState(false);
    const [isMFAModalActive, setMFAModalActive] = useState(false);

    const [phoneNumber, setPhoneNumber] = useState('');
    const [isPhoneNumberRequired, setIsPhoneNumberRequired] = useState(false);
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
    const [displayDialCode, setDisplayDialCode] = useState('+44');

    const MFAModal = () => {
        if(!phoneNumber) {
            setIsPhoneNumberRequired(true);
            return false;
        }
        setIsModalActive(true);
        setMFAModalActive(true);
    };

    const onCloseModal = () => {
        setIsModalActive(false);
        setMFAModalActive(false);
    };

    const handleConfirmMFAEnable = () => {
        onCloseModal();
        props.onMFAEnableSave && props.onMFAEnableSave(phoneNumber);
    }

    const handleSelectFlag = (value: any) => {
        const selectedFlagElement = document.getElementsByClassName('selected-flag');
        if(selectedFlagElement && selectedFlagElement.length > 0) {
            const title = selectedFlagElement[0].getAttribute('title');
            const trimmedValue = title?.split(': ');
            if(trimmedValue && trimmedValue?.length > 0) {
                setDisplayDialCode(trimmedValue[1]);
            }
            
        }
    };

    const handlePhoneNumberChange = (isValid: boolean, value: string, countryData: any) => {
        if(!value) {
            setPhoneNumber('');
            setIsPhoneNumberRequired(true);
            return false;
        } else {
            setIsPhoneNumberRequired(false);
        }

        // Get the dial code
        const dialCode = countryData?.dialCode; // This will give you the country code
        setDisplayDialCode(`+${dialCode}`);
        setIsPhoneNumberValid(isValid);
        
        // Sanitize the phone number by removing spaces, brackets, and non-numeric characters
        const sanitizedValue = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters

        // Combine the dial code and sanitized phone number without spaces or brackets
        const combinedNumber = `+${dialCode}${sanitizedValue}`; // Concatenate dial code and sanitized phone number
        setPhoneNumber(combinedNumber); // Update the state
    };

    return (
        <div>
            {props.mfaStatus === "ENABLED" ? (
                <div className='accounts-profile-binder'>
                    <div className='accounts-profile-sub-binder'>
                        {/* Security - MFA */}
                        <div className='ac-profile-componets'>
                            <p className='text-center font-styelRegular mt-3'> {t("Your MFA has already been enabled.")}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className='accounts-profile-binder'>
                    <div className='accounts-profile-sub-binder'>
                        {/* Security - MFA */}
                        <div className='ac-profile-componets'>
                            <p className='text-center font-styelRegular mt-3'> {t("Protect your account by adding an extra layer of security.")}</p>

                            <div className='custom-phone-input-wrapper'>
                                <p className='m-0 font-styleBold mb-2'>{t("Mobile Number")} *</p>
                                <div className='input-group mb-3'>
                                    {/* <span className='input-group-text'>{displayDialCode}</span> */}
                                    <ReactIntlTelInput
                                        preferredCountries={["gb", "us"]}
                                        defaultCountry={"gb"}
                                        customPlaceholder={(selectedCountryPlaceholder) => `e.g. ${selectedCountryPlaceholder}`}
                                        onPhoneNumberChange={handlePhoneNumberChange}
                                        onSelectFlag={handleSelectFlag}
                                    />
                                </div>
                                {/* Validations */}
                                {!phoneNumber && isPhoneNumberRequired && (
                                    <div className='addres-errors-msgs mb-3'>
                                        <div className='adres-err'>
                                            <p>{t("Mobile number is required")}</p>
                                        </div>
                                    </div>
                                )}
                                {phoneNumber && !isPhoneNumberValid && (
                                    <div className='addres-errors-msgs mb-3'>
                                        <div className='adres-err'>
                                            <p>{t("Enter a valid mobile number")}</p>
                                        </div>
                                    </div>
                                )}
                                <div className='profile-details-dynamic-value-button text-center pt-4'>
                                    <Button
                                        label={t("Enable")}
                                        width='100%'
                                        disabled={!isPhoneNumberValid || isPhoneNumberRequired}
                                        type='secondary'
                                        onClick={MFAModal}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {isModalActive && (
                        <div className='modal-accounts'>
                            <Modal
                                open={isModalActive}
                                closeOnDimmerClick={true}
                                closeOnDocumentClick={true}
                                className='modal-accounts-main'>
                                {/* inside tags */}
                                <div className='accounts-profile-all-content-binder'>
                                    <div className='accounts-profile-all-content-sub-binder'>
                                        {isMFAModalActive && (
                                            <div className='email-modal'>
                                                <div className='modal-head-con'>
                                                    <div className='model-text'>
                                                        <p className='m-0 model-text-head font-styleBold'>
                                                            <Trans i18nKey='mfaEnableTitle'>
                                                                Two-Step
                                                                <br />
                                                                Verification
                                                            </Trans>
                                                        </p>
                                                    </div>
                                                    <div className='modal-cross'>
                                                        <FiX
                                                            onClick={onCloseModal}
                                                            data-testid='close-modal'
                                                            className='crossing-icon-modal'
                                                        />
                                                    </div>
                                                </div>
                                                {/* modal body */}
                                                <div className='modal-inputs-all'>
                                                    {/* confirmation message */}
                                                    <div className='confirmation-msg-on-accounts-email'>
                                                        <div className='confirmation-msg-on-accounts-email-binder'>
                                                            <p className='m-0 font-styleRegualr'>
                                                                {t("You will be logged out of your account to set up Two-Step Authentication.")}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='modal-footer-accounts flex justify-center'>
                                                        <div className='modal-accounts-btns flex flex-col items-center'>
                                                            <div className='modal-accounts-primnary-btn'>
                                                                <Button
                                                                    label={t("Confirm")}
                                                                    width='270px'
                                                                    disabled={false}
                                                                    type='secondary'
                                                                    onClick={handleConfirmMFAEnable}
                                                                />
                                                            </div>
                                                            <a
                                                                className='mt-4 text-center cursor-pointer text-primary'
                                                                onClick={onCloseModal}>
                                                                {t("Skip")}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default ActivateMFA;